{
  "title": "Notifications",
  "bell": {
    "label": "Notifications",
    "labelUnread": "Notifications: {{n}} unread"
  },
  "filter": {
    "label": "Which notifications",
    "all": "All",
    "unread": "Unread"
  },
  "markAllRead": "Mark all read",
  "unread": "Unread",
  "latest": "The latest {{shown}} of {{total}}",
  "empty": {
    "title": "You're all caught up",
    "all": "Updates on your work appear here.",
    "unread": "Nothing new since you last looked."
  },
  "unavailable": "Notifications could not be loaded",
  "kinds": {
    "TASK_ASSIGNED": {
      "actor": "{{actor}} assigned {{number}} to you",
      "system": "{{number}} was assigned to you"
    },
    "TASK_UNASSIGNED": {
      "actor": "{{actor}} gave {{number}} to someone else",
      "system": "{{number}} was given to someone else"
    },
    "TASK_QUEUED": {
      "actor": "{{actor}} added {{number}} to your team's queue",
      "system": "{{number}} is waiting in your team's queue"
    },
    "TASK_REVIEW_REQUESTED": {
      "actor": "{{actor}} asked for your review on {{number}}",
      "system": "Your review was requested on {{number}}"
    },
    "TASK_RETURNED": {
      "actor": "{{actor}} returned {{number}} to you with feedback",
      "system": "{{number}} was returned with feedback"
    },
    "TASK_COMPLETED": {
      "actor": "{{actor}} completed {{number}}",
      "system": "{{number}} was completed"
    },
    "TASK_CANCELLED": {
      "actor": "{{actor}} cancelled {{number}}",
      "system": "{{number}} was cancelled"
    },
    "TASK_REOPENED": {
      "actor": "{{actor}} reopened {{number}}",
      "system": "{{number}} was reopened"
    },
    "TASK_COMMENTED": {
      "actor": "{{actor}} commented on {{number}}",
      "system": "New comment on {{number}}"
    },
    "TASK_DUE_CHANGED": {
      "actor": "{{actor}} moved the due date of {{number}} to {{date}}",
      "system": "{{number}} is now due on {{date}}",
      "actorCleared": "{{actor}} removed the due date of {{number}}",
      "systemCleared": "{{number}} no longer has a due date"
    },
    "TASK_DATE_REQUESTED": {
      "actor": "{{actor}} asks to move the due date of {{number}} to {{date}}",
      "system": "A new due date, {{date}}, was requested for {{number}}"
    },
    "TASK_BLOCKED": {
      "actor": "{{actor}} marked {{number}} as blocked",
      "system": "{{number}} is blocked",
      "actorFollowUp": "{{actor}} marked {{number}} as blocked, to follow up on {{date}}",
      "systemFollowUp": "{{number}} is blocked, to follow up on {{date}}"
    },
    "TASK_UNBLOCKED": {
      "actor": "{{actor}} unblocked {{number}}",
      "system": "{{number}} is no longer blocked"
    },
    "TASK_PERSON_ADDED": {
      "CONTRIBUTOR": {
        "actor": "{{actor}} added you to {{number}} as a contributor",
        "system": "You were added to {{number}} as a contributor"
      },
      "FOLLOWER": {
        "actor": "{{actor}} added you to {{number}} as a follower",
        "system": "You now follow {{number}}"
      }
    },
    "TASK_DUE_TODAY": "{{number}} is due today",
    "TASK_OVERDUE": {
      "undated": "{{number}} is overdue",
      "days_one": "{{number}} is {{n}} day overdue",
      "days_other": "{{number}} is {{n}} days overdue"
    },
    "TASK_OVERDUE_ESCALATED": {
      "undated": "{{number}}, in a team you lead, is overdue",
      "days_one": "{{number}}, in a team you lead, is {{n}} day overdue",
      "days_other": "{{number}}, in a team you lead, is {{n}} days overdue"
    },
    "TASK_FOLLOW_UP_DUE": "Today is the day to follow up on what blocks {{number}}",
    "SERVICE_VISIT_SCHEDULED": {
      "actor": "{{actor}} scheduled a visit of {{number}} for your team",
      "system": "A visit of {{number}} was scheduled for your team"
    },
    "SERVICE_VISIT_RESCHEDULED": {
      "actor": "{{actor}} rescheduled a visit of {{number}}",
      "system": "A visit of {{number}} was rescheduled"
    },
    "SERVICE_VISIT_CANCELLED": {
      "actor": "{{actor}} cancelled a visit of {{number}}",
      "system": "A visit of {{number}} was cancelled"
    },
    "SERVICE_FOLLOW_UP_REQUESTED": {
      "actor": "{{actor}} asks for a follow-up visit on {{number}}",
      "system": "A follow-up visit is requested on {{number}}"
    },
    "SERVICE_FOLLOW_UP_APPROVED": {
      "actor": "{{actor}} approved your follow-up visit on {{number}}",
      "system": "Your follow-up visit on {{number}} was approved"
    },
    "SERVICE_FOLLOW_UP_RETURNED": {
      "actor": "{{actor}} returned your follow-up request on {{number}}",
      "system": "Your follow-up request on {{number}} was returned"
    },
    "SERVICE_COLLECTION_REPORTED": {
      "actor": "{{actor}} reported a payment collected on {{number}}: verify it",
      "system": "A payment collected on {{number}} awaits verification"
    },
    "SERVICE_COLLECTION_VERIFIED": {
      "actor": "{{actor}} verified the payment you collected on {{number}}",
      "system": "The payment you collected on {{number}} was verified"
    },
    "SERVICE_COLLECTION_REJECTED": {
      "actor": "{{actor}} rejected the payment you reported on {{number}}",
      "system": "The payment you reported on {{number}} was rejected"
    },
    "SERVICE_CHECK_ISSUE": {
      "actor": "{{actor}} found an issue on {{asset}} at {{site}}: fault job {{job}}",
      "system": "An issue was found on {{asset}} at {{site}}: fault job {{job}}",
      "actorPlain": "{{actor}} found an issue on a check: fault job {{job}}",
      "systemPlain": "An issue was found on a check: fault job {{job}}"
    },
    "CONTRACT_RENEWAL_DUE": {
      "days_one": "{{contract}} ends in {{n}} day ({{date}})",
      "days_other": "{{contract}} ends in {{n}} days ({{date}})",
      "dated": "{{contract}} ends on {{date}}",
      "plain": "{{contract}} ends soon"
    },
    "CONTRACT_EXPIRED": {
      "dated": "{{contract}} expired on {{date}}",
      "plain": "{{contract}} has expired"
    },
    "CONTRACT_BILLING_READY": {
      "count_one": "{{n}} instalment of {{contract}} is ready to invoice ({{total}})",
      "count_other": "{{n}} instalments of {{contract}} are ready to invoice ({{total}})",
      "plain": "Instalments of {{contract}} are ready to invoice"
    },
    "CONTRACT_VISITS_PLANNED": {
      "count_one": "{{n}} planned visit of {{contract}} is ready to schedule",
      "count_other": "{{n}} planned visits of {{contract}} are ready to schedule",
      "countSites_one": "{{n}} planned visit of {{contract}} is ready to schedule, at {{sites}}",
      "countSites_other": "{{n}} planned visits of {{contract}} are ready to schedule, at {{sites}}",
      "sites_one": "{{n}} site",
      "sites_other": "{{n}} sites",
      "plain": "Planned visits of {{contract}} are ready to schedule"
    },
    "CONTRACT_VISIT_OVERDUE": {
      "site": "Planned visit {{job}} at {{site}} is overdue: it was due on {{date}}",
      "dated": "Planned visit {{job}} is overdue: it was due on {{date}}",
      "plain": "Planned visit {{job}} is overdue"
    },
    "ASSET_WARRANTY_EXPIRING": {
      "site": "The warranty of {{asset}} at {{site}} ends on {{date}}",
      "dated": "The warranty of {{asset}} ends on {{date}}",
      "plain": "An asset's warranty under {{contract}} ends soon"
    },
    "DSR_DUE_SOON": {
      "days_one": "The personal-data request from {{number}} is due in {{n}} working day, on {{date}}",
      "days_other": "The personal-data request from {{number}} is due in {{n}} working days, on {{date}}"
    },
    "DSR_OVERDUE": {
      "days_one": "The personal-data request from {{number}} is {{n}} day past its legal deadline",
      "days_other": "The personal-data request from {{number}} is {{n}} days past its legal deadline"
    },
    "PROJECT_MEMBER_ADDED": {
      "actor": "{{actor}} added you to the team of {{number}}",
      "system": "You were added to the team of {{number}}"
    },
    "PROJECT_MANAGER_ASSIGNED": {
      "actor": "{{actor}} made you the manager of {{number}}",
      "system": "You are now the manager of {{number}}"
    },
    "PROJECT_STATUS_CHANGED": {
      "actor": "{{actor}} changed the status of {{number}}",
      "system": "The status of {{number}} changed"
    },
    "PROJECT_BUDGET_THRESHOLD": {
      "actor": "{{number}} is close to its budget",
      "system": "{{number}} is close to its budget",
      "WARN": "{{number}} has reached the warning level of its budget",
      "CRITICAL": "{{number}} has reached the critical level of its budget"
    },
    "PROJECT_BUDGET_SUBMITTED": {
      "actor": "{{actor}} sent the budget of {{number}} for your approval",
      "system": "The budget of {{number}} waits for your approval"
    },
    "PROJECT_BUDGET_APPROVED": {
      "actor": "{{actor}} approved the budget of {{number}}",
      "system": "The budget of {{number}} was approved"
    },
    "PROJECT_BILLING_READY": {
      "actor": "{{actor}} marked “{{item}}” of {{number}} ready to invoice",
      "system": "“{{item}}” of {{number}} is ready to invoice",
      "actorPlain": "{{actor}} marked a billing item of {{number}} ready to invoice",
      "systemPlain": "A billing item of {{number}} is ready to invoice"
    },
    "PROJECT_CLAIM_SUBMITTED": {
      "actor": "{{actor}} submitted claim {{claim}} of {{number}}",
      "system": "Claim {{claim}} of {{number}} was submitted",
      "actorPlain": "{{actor}} submitted a progress claim of {{number}}",
      "systemPlain": "A progress claim of {{number}} was submitted"
    },
    "PROJECT_CLAIM_CERTIFIED": {
      "actor": "{{actor}} recorded the certification of claim {{claim}} of {{number}}: its invoice is issued",
      "system": "Claim {{claim}} of {{number}} is certified: its invoice is issued",
      "actorPlain": "{{actor}} recorded the certification of a progress claim of {{number}}",
      "systemPlain": "A progress claim of {{number}} is certified"
    },
    "PROJECT_CLAIM_REJECTED": {
      "actor": "{{actor}} recorded the client’s rejection of claim {{claim}} of {{number}}",
      "system": "The client rejected claim {{claim}} of {{number}}",
      "actorPlain": "{{actor}} recorded the client’s rejection of a progress claim of {{number}}",
      "systemPlain": "The client rejected a progress claim of {{number}}"
    },
    "PROJECT_CLAIM_VOIDED": {
      "actor": "{{actor}} voided claim {{claim}} of {{number}} and its invoice",
      "system": "Claim {{claim}} of {{number}} and its invoice were voided",
      "actorPlain": "{{actor}} voided a progress claim of {{number}}",
      "systemPlain": "A progress claim of {{number}} was voided"
    },
    "PROJECT_VARIATION_DECIDED": {
      "APPROVED": {
        "actor": "{{actor}} recorded the client’s approval of {{variation}} on {{number}}",
        "system": "The client approved {{variation}} on {{number}}",
        "actorPlain": "{{actor}} recorded the client’s approval of a variation on {{number}}",
        "systemPlain": "The client approved a variation on {{number}}"
      },
      "REJECTED": {
        "actor": "{{actor}} recorded the client’s rejection of {{variation}} on {{number}}",
        "system": "The client rejected {{variation}} on {{number}}",
        "actorPlain": "{{actor}} recorded the client’s rejection of a variation on {{number}}",
        "systemPlain": "The client rejected a variation on {{number}}"
      }
    },
    "PROJECT_SIGNAL": {
      "signal": "{{number}}: {{signal}}",
      "plain": "{{number}} has a new alert"
    },
    "PROJECT_SIGNAL_DIGEST": {
      "count_one": "{{n}} more project alert today",
      "count_other": "{{n}} more project alerts today",
      "plain": "More project alerts today"
    },
    "PROJECT_GUARANTEE_EXPIRING": {
      "days_one": "{{guarantee}} of {{number}} expires in {{n}} day, on {{date}}",
      "days_other": "{{guarantee}} of {{number}} expires in {{n}} days, on {{date}}",
      "dated": "{{guarantee}} of {{number}} expires on {{date}}",
      "plain": "A guarantee of {{number}} expires soon"
    },
    "PROJECT_GUARANTEE_EXPIRED": {
      "dated": "{{guarantee}} of {{number}} expired on {{date}}",
      "plain": "A guarantee of {{number}} has expired"
    },
    "PROJECT_RECONCILIATION_DIFFERENCE": {
      "identity": "{{number}}: the ledger and Projects differ on {{account}} at {{date}}",
      "plain": "The contract figures of {{number}} don't reconcile with the ledger",
      "untraced": "The ledger has {{account}} postings that trace to no project at {{date}}"
    },
    "PROJECT_CONTRACT_APPROVAL_PENDING": "{{name}} of {{project}} waits for your approval",
    "PROJECT_CONTRACT_APPROVAL_RETURNED": {
      "actor": "{{name}} of {{project}} was returned to draft by {{actor}}",
      "actorReason": "{{name}} of {{project}} was returned to draft by {{actor}}: {{reason}}",
      "system": "{{name}} of {{project}} was returned to draft",
      "systemReason": "{{name}} of {{project}} was returned to draft: {{reason}}"
    },
    "PROJECT_TIME_SUBMITTED": {
      "hours_one": "{{person}} submitted {{hours}} on {{project}} for the week of {{date}} ({{n}} entry)",
      "hours_other": "{{person}} submitted {{hours}} on {{project}} for the week of {{date}} ({{n}} entries)",
      "plain": "Time on {{project}} waits for your approval"
    },
    "PROJECT_TIME_RETURNED": {
      "actor_one": "{{actor}} returned {{n}} entry of your time on {{project}} (week of {{date}})",
      "actor_other": "{{actor}} returned {{n}} entries of your time on {{project}} (week of {{date}})",
      "actorReason_one": "{{actor}} returned {{n}} entry of your time on {{project}} (week of {{date}}): {{reason}}",
      "actorReason_other": "{{actor}} returned {{n}} entries of your time on {{project}} (week of {{date}}): {{reason}}",
      "plain": "Some of your time on {{project}} was returned to you"
    },
    "AI_BUDGET_THRESHOLD": {
      "percent": "The AI assistant used {{pct}} of this month's tokens ({{used}} of {{limit}})",
      "percentMonth": "The AI assistant used {{pct}} of the tokens for {{month}} ({{used}} of {{limit}})",
      "reached": "The AI assistant used all of this month's tokens ({{used}} of {{limit}}). It stops until next month, unless an administrator raises the limit in Settings › AI assistant, or your Sahab provider raises its cap.",
      "reachedMonth": "The AI assistant used all of the tokens for {{month}} ({{used}} of {{limit}})",
      "plain": "The AI assistant is close to its monthly token limit"
    },
    "BOOKS_HEALTH_DIGEST": {
      "summary": "Books health, {{period}}: {{counts}} to look at",
      "critical_one": "{{n}} critical problem",
      "critical_other": "{{n}} critical problems",
      "warning_one": "{{n}} warning",
      "warning_other": "{{n}} warnings",
      "and": "{{first}} and {{second}}",
      "range": "{{from}} to {{to}}",
      "plain": "Books health found problems to look at"
    },
    "CHEQUES_DUE": {
      "received": "{{cheques}} ({{amount}}) in hand and due: deposit them",
      "receivedLate": "{{cheques}} ({{amount}}) in hand and due to deposit; {{late}} deposited and not cleared yet",
      "lateOnly": "{{late}} deposited and not cleared yet: check with the bank",
      "issued": "{{cheques}} you wrote ({{amount}}) may be presented by {{date}}: keep the money in the bank",
      "cheques_one": "{{n}} cheque",
      "cheques_other": "{{n}} cheques",
      "plain": "Cheques wait to be followed up"
    },
    "EMPLOYEE_DOCUMENTS_EXPIRING": {
      "summary": "{{documents}} reach a reminder day: {{expired}} expired, {{within7}} due within 7 days, {{within30}} within 30 days",
      "documents_one": "{{n}} employee document",
      "documents_other": "{{n}} employee documents",
      "plain": "Employee documents are expiring"
    }
  },
  "contractRecord": {
    "variation": "Variation {{number}}",
    "variationTitled": "Variation {{number}} “{{title}}”",
    "claim": "Claim {{number}}",
    "claimInterim": "Interim claim to {{date}}",
    "claimFinal": "Final claim",
    "claimDraft": "Progress claim"
  },
  "guaranteeName": {
    "numbered": "{{type}} {{reference}}",
    "directed": "{{name}} ({{direction}})",
    "GIVEN": "given",
    "RECEIVED": "received"
  },
  "contractName": "{{number}} for {{customer}}"
}
